export default __webpack_public_path__ + "static/Contact-us-animation4-8c91b20990473c27afd0b6c739b41389.gif";